import { useContext, useEffect } from "react";
import AiAssistantContext from "./AiAssistantContext";

/**
 * Registers a card-level AI insight with the AI Assistant bubble.
 * Pass null as filterParams to skip registration (e.g. while card data is still loading).
 * On unmount the insight is automatically removed.
 *
 * @param cardKey   - Unique key for this card, sent to the API as `pageName`
 * @param filterParams - Computed metrics for this card, or null to skip
 */
const useAiInsight = (cardKey: string, filterParams: Record<string, any> | null) => {
  const ctx = useContext(AiAssistantContext);

  useEffect(() => {
    if (!ctx || !filterParams) return;
    ctx.registerInsight(cardKey, filterParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardKey, JSON.stringify(filterParams)]);

  useEffect(() => {
    return () => {
      if (ctx) ctx.unregisterInsight(cardKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAiInsight;
